<template>
<v-container>
  <v-alert error dismissible @input="onClose" :value="true" class="red--text">
    {{ alerttext }}
  </v-alert>
</v-container>
</template>

<script>
  export default {
    props: ['alerttext'],
    methods: {
      onClose () {
        this.$emit('dismissed')
      }
    }
  }
</script>
